import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_manual_journals } from "../../../../Controllers/Accounting/Services/manualJournalsService";
import toast from "react-hot-toast";
import headers from "../../../../Data/Tables/Accounting/ReportEntry/GeneralLedger/headers";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const GeneralLedgerTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    console.log("in form data", data);
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      console.log("table data in fetchdata", tabledata);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        startDate: tabledata?.date?.start,
        endDate: tabledata?.date?.end,
        page: tabledata?.currentPage,
        limit: 10,
      };

      const response = await get_all_manual_journals(data);

      if (response?.success) {
        const journalEntries = response.data || [];

        const tableBody = transformJournalEntriesToLedgerFormat(journalEntries);
        setBody(tableBody);

        setPagination({
          currentPage: response.meta?.currentPage || 1,
          totalCount: response.meta?.totalCount || journalEntries.length,
          totalPages: response.meta?.totalPages || 1,
        });

        setLoader(false);
      } else {
        setLoader(false);
        toast.error("Failed to load ledger entries");
      }
    } catch (error) {
      setLoader(false);
      console.error("Failed to load ledger entries:", error.message);
      toast.error(error.message);
    }
  };

  const transformJournalEntriesToLedgerFormat = (journalEntries) => {
    return journalEntries.map((journal) => {
      const entries = journal.entries.map((entry, index) => ({
        number: index + 1,
        journalId: journal.entryId,
        transactionId: entry.reference,
        date: moment(journal.date).format("YYYY-MM-DD"),
        description: journal.description,
        transactionDebit:
          entry.type === "debit"
            ? parseFloat(entry.amount).toFixed(3)
            : "0.000",
        transactionCredit:
          entry.type === "credit"
            ? parseFloat(entry.amount).toFixed(3)
            : "0.000",
        accountName: entry.account ? entry.account.name : "N/A",
        balanceDebit:
          entry.type === "debit"
            ? entry.account && entry.account.balance > 0
              ? parseFloat(entry.account.balance).toFixed(3)
              : 0
            : "0.000",
        balanceCredit:
          entry.type === "credit" && entry.account
            ? parseFloat(entry.account.balance).toFixed(3)
            : "0.000",
      }));

      const subtotal = {
        isSubtotal: true,
        journalId: journal.entryId,
        totalDebit: entries.reduce(
          (sum, e) => sum + parseFloat(e.transactionDebit),
          0
        ),
        totalCredit: entries.reduce(
          (sum, e) => sum + parseFloat(e.transactionCredit),
          0
        ),
        totalBalDebit: entries.reduce(
          (sum, e) => sum + parseFloat(e.balanceDebit),
          0
        ),
        totalBalCredit: entries.reduce(
          (sum, e) => sum + parseFloat(e.balanceCredit),
          0
        ),
      };

      return { journalId: journal.entryId, entries, subtotal };
    });
  };

  const fetchExportData = async () => {
    try {
      const data = { source: "GeneralLedger" };
      const response = await get_all_manual_journals(data);

      if (response?.success) {
        return response.data || [];
      } else {
        toast.error("Failed to fetch export data");
        return [];
      }
    } catch (error) {
      console.error("Export fetch error:", error);
      toast.error("Failed to fetch export data");
      return [];
    }
  };

  const exportExcel = async () => {
    const journalEntries = await fetchExportData();

    if (!journalEntries.length) return;

    const headerRow = [
      "Number",
      "Journal ID",
      "Transaction ID",
      "Date",
      "Description",
      "Transaction Debit",
      "Transaction Credit",
      "Balance Debit",
      "Balance Credit",
    ];

    const rows = [];
    let serialNumber = 1;

    journalEntries.forEach((journal) => {
      const debitEntry = journal.entries.find(
        (entry) => entry.type === "debit"
      );

       console.log("debit", debitEntry)
      if (debitEntry) {
        rows.push([
          serialNumber++,
          journal.entryId,
          debitEntry.reference,
          moment(journal.date).format("YYYY-MM-DD"),
          journal.description,
          parseFloat(debitEntry.amount).toFixed(3),
          "0.000",
          parseFloat(debitEntry.account.balance).toFixed(3),
          "0.000",
        ]);
      }

      const creditEntry = journal.entries.find(
        (entry) => entry.type === "credit"
      );
      console.log("Creditt", creditEntry)
      if (creditEntry) {
        rows.push([
          serialNumber++,
          journal.entryId,
          creditEntry.reference,
          moment(journal.date).format("YYYY-MM-DD"),
          journal.description,
          "0.000",
          parseFloat(creditEntry.amount).toFixed(3),
          "0.000",
          parseFloat(creditEntry?.account?.balance).toFixed(3),
        ]);
      }
    });

    const content = [headerRow, ...rows].map((e) => e.join("\t")).join("\n");

    const blob = new Blob([content], { type: "application/vnd.ms-excel" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `general_ledger_${moment().format("YYYY-MM-DD")}.xls`;
    link.click();
  };

  const exportPDF = async () => {
    const journalEntries = await fetchExportData();

    if (!journalEntries.length) return;

    const doc = new jsPDF();
    doc.text("General Ledger Report", 14, 15);

    const rows = [];
    let serialNumber = 1;

    journalEntries.forEach((journal) => {
      const debitEntry = journal.entries.find(
        (entry) => entry.type === "debit"
      );
      if (debitEntry) {
        rows.push([
          serialNumber++,
          journal.entryId,
          debitEntry.reference,
          moment(journal.date).format("YYYY-MM-DD"),
          journal.description,
          parseFloat(debitEntry.amount).toFixed(3),
          "0.000",
          parseFloat(debitEntry.account.balance).toFixed(3),
          "0.000",
        ]);
      }

      const creditEntry = journal.entries.find(
        (entry) => entry.type === "credit"
      );
      if (creditEntry) {
        rows.push([
          serialNumber++,
          journal.entryId,
          creditEntry.reference,
          moment(journal.date).format("YYYY-MM-DD"),
          journal.description,
          "0.000",
          parseFloat(creditEntry.amount).toFixed(3),
          "0.000",
          parseFloat(creditEntry.account.balance).toFixed(3),
        ]);
      }
    });

    autoTable(doc, {
      head: [
        [
          "Number",
          "Journal ID",
          "Transaction ID",
          "Date",
          "Description",
          "Trans Debit",
          "Trans Credit",
          "Bal Debit",
          "Bal Credit",
        ],
      ],
      body: rows,
      startY: 20,
    });

    doc.save(`general_ledger_${moment().format("YYYY-MM-DD")}.pdf`);
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  const handleNext = () => {
    let currentPage = parseInt(pagination?.currentPage) + 1;

    if (currentPage <= parseInt(pagination?.totalPages)) {
      let data = {
        ...pagination,
        currentPage: currentPage,
      };

      paginationdata(data);
    }
  };

  const handlePrevious = () => {
    let currentPage = parseInt(pagination?.currentPage) - 1;

    if (currentPage > 0) {
      let data = {
        ...pagination,
        currentPage: currentPage,
      };

      paginationdata(data);
    }
  };

  const totals = body.reduce(
    (acc, item) => {
      if (item && Array.isArray(item.entries)) {
        if (item.subtotal) {
          acc.debit += Number(item.subtotal.totalDebit || 0);
          acc.credit += Number(item.subtotal.totalCredit || 0);
          acc.balanceDebit += Number(item.subtotal.totalBalDebit || 0);
          acc.balanceCredit += Number(item.subtotal.totalBalCredit || 0);
        } else {
          item.entries.forEach((e) => {
            acc.debit += Number(e.transactionDebit || 0);
            acc.credit += Number(e.transactionCredit || 0);
            acc.balanceDebit += Number(e.balanceDebit || 0);
            acc.balanceCredit += Number(e.balanceCredit || 0);
          });
        }
      } else {
        acc.debit += Number(item.transactionDebit || 0);
        acc.credit += Number(item.transactionCredit || 0);
        acc.balanceDebit += Number(item.balanceDebit || 0);
        acc.balanceCredit += Number(item.balanceCredit || 0);
      }
      return acc;
    },
    { debit: 0, credit: 0, balanceDebit: 0, balanceCredit: 0 }
  );

  const totalDebit = totals.debit;
  const totalCredit = totals.credit;
  const totalBalanceDebit = totals.balanceDebit;
  const totalBalanceCredit = totals.balanceCredit;

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  console.log("body of the general ledger", body);

  return (
    <Header
      headers={header}
      setHeaders={setHeader}
      formdata={formdata}
      title="General Ledger Report"
    >
      <div className="flex gap-3 mb-3 justify-end">
        <button
          onClick={exportExcel}
          className="px-4 py-2 rounded border border-gray-500 text-gray-600 bg-transparent hover:bg-gray-100 active:bg-gray-200 active:scale-95 transition-all duration-100"
        >
          Export as Excel
        </button>
        <button
          onClick={exportPDF}
          className="px-4 py-2 rounded border border-gray-500 text-gray-600 bg-transparent hover:bg-gray-100 active:bg-gray-200 active:scale-95 transition-all duration-100"
        >
          Export as PDF
        </button>
      </div>

      <Loadercomponent loader={loader}>
        <div className="w-full bg-white rounded-md overflow-hidden">
          <div
            style={{
              maxHeight: "70vh",
              overflow: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
            className="no-horizontal-scrollbar"
          >
            <table className="w-full">
              <thead>
                <tr className="sticky top-0 z-50 border-b bg-white">
                  <th className="p-4 text-left font-normal">Number</th>
                  <th className="p-4 text-left font-normal">Journal ID</th>
                  <th className="p-4 text-left font-normal">Transaction ID</th>
                  <th className="p-4 text-left font-normal">Account Name</th>
                  <th className="p-4 text-left font-normal">Date</th>
                  <th className="p-4 text-left font-normal">Description</th>
                  <th className="p-4 text-right font-normal" colSpan="2">
                    Transaction
                  </th>
                  <th className="p-4 text-right font-normal" colSpan="2">
                    Balance
                  </th>
                </tr>
                <tr className="sticky top-20 z-50 border-b bg-white">
                  <th className="p-4 text-left font-normal" colSpan="6"></th>
                  <th className="p-4 text-right font-normal">Debit (OMR)</th>
                  <th className="p-4 text-right font-normal">Credit (OMR)</th>
                  <th className="p-4 text-right font-normal">Debit (OMR)</th>
                  <th className="p-4 text-right font-normal">Credit (OMR)</th>
                </tr>
              </thead>
              <tbody>
                {body.map((journalGroup, groupIndex) => {
                  const { journalId, entries, subtotal } = journalGroup;
                  return (
                    <React.Fragment key={groupIndex}>
                      {entries.map((entry, entryIndex) => (
                        <tr
                          key={entryIndex}
                          className="border-b hover:bg-gray-50"
                        >
                          {entryIndex === 0 && (
                            <td
                              rowSpan={entries.length}
                              className="p-4 font-normal text-center align-top"
                            >
                              {groupIndex + 1}
                            </td>
                          )}
                          {entryIndex === 0 && (
                            <td
                              rowSpan={entries.length}
                              className="p-4 font-normal text-center align-top"
                            >
                              {journalId}
                            </td>
                          )}
                          <td className="p-4">{entry.transactionId}</td>
                          <td className="p-4">{entry.accountName}</td>
                          <td className="p-4">{entry.date}</td>
                          <td className="p-4">{entry.description}</td>
                          <td className="p-4 text-right">
                            {entry.transactionDebit}
                          </td>
                          <td className="p-4 text-right">
                            {entry.transactionCredit}
                          </td>
                          <td className="p-4 text-right">
                            {entry.balanceDebit}
                          </td>
                          <td className="p-4 text-right">
                            {entry.balanceCredit}
                          </td>
                        </tr>
                      ))}

                      <tr className="bg-gray-50 font-medium border-b">
                        <td
                          colSpan={6}
                          className="p-4 text-right font-semibold"
                        >
                          Subtotal
                        </td>
                        <td className="p-4 text-right font-semibold">
                          {subtotal.totalDebit.toFixed(3)}
                        </td>
                        <td className="p-4 text-right font-semibold">
                          {subtotal.totalCredit.toFixed(3)}
                        </td>
                        <td className="p-4 text-right font-semibold">
                          {subtotal.totalBalDebit.toFixed(3)}
                        </td>
                        <td className="p-4 text-right font-semibold">
                          {subtotal.totalBalCredit.toFixed(3)}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
              {body.length > 0 && (
                <tfoot>
                  <tr className="bg-gray-200 font-bold border-t">
                    <td colSpan={6} className="p-4 text-right">
                      TOTAL (OMR)
                    </td>
                    <td className="p-4 text-right">{totalDebit.toFixed(3)}</td>
                    <td className="p-4 text-right">{totalCredit.toFixed(3)}</td>
                    <td className="p-4 text-right">
                      {totalBalanceDebit.toFixed(3)}
                    </td>
                    <td className="p-4 text-right">
                      {totalBalanceCredit.toFixed(3)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
          {pagination?.currentPage && (
            <div className="border-t p-4">
              <div className="flex justify-between text-gray-600 text-sm font-medium">
                <div>
                  <span className="pr-3">TOTAL</span>
                  <span className="pl-5">
                    {pagination?.currentPage > 1
                      ? (pagination?.currentPage - 1) * 10 + 1
                      : 1}{" "}
                    -{" "}
                    {Math.min(
                      pagination?.currentPage * 10,
                      pagination?.totalCount
                    )}
                    &nbsp;OF&nbsp;{pagination?.totalCount}
                  </span>
                </div>
                <div className="flex items-center">
                  <button
                    type="button"
                    className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be]"
                    onClick={handlePrevious}
                  >
                    <div className="text-center text-xs text-gray-900">
                      <LeftOutlined />
                    </div>
                  </button>
                  <span className="px-3">
                    {pagination?.currentPage} OUT OF {pagination?.totalPages}
                  </span>
                  <button
                    className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be]"
                    onClick={handleNext}
                  >
                    <div className="text-center text-xs text-gray-600">
                      <RightOutlined />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default GeneralLedgerTable;
